export default __webpack_public_path__ + "static/media/more.f09e42f4.svg";